<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E5%B9%BF%E5%91%8A%E6%9D%A1.png"
			alt="" />
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">农业产业AI大模型--AI全域农业专家</div>
		<div class="title-desc">引领农业产业智慧化全新变革 破解农业生产标准化难题</div>
		<img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E9%AB%98%E4%BA%A7%E6%96%B9%E6%A1%88.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">模型价值</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E4%BB%B7%E5%80%BC2.png"
			alt="" />
		
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20251007112704.png"
			alt="" />
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>